<template>
    <div class="flex">
        <div class="w-full">
            <div class="column-title">Scale</div>
            <ul class="list-none p-0">
                <li>
                    <label for="Linear">
                        <input id="Linear" type="radio" v-model="form.scaleType" value="Linear" name="scaleType" class="mr-1">
                        Linear
                    </label>
                </li>
                <li>
                    <label for="Logarithmic">
                        <input id="Logarithmic" type="radio" v-model="form.scaleType" value="Logarithmic" name="scaleType" class="mr-1">
                        Logarithmic
                    </label>
                </li>
            </ul>
            <div class="column-title">Right Margin</div>
            <div class="flex items-center">
                <label class="font-normal">
                    <input class="form-control form-input-sm-inline mr-1" style="width: 24%;" type="text" name="marginBars" v-model.number="form.marginBars">
                    Bars (25 Max)
                </label>
            </div>
            <div class="column-title mt-2">Scale Values</div>
            <ul class="list-none p-0">
                <li>
                    <label for="priceChange">
                        <input id="priceChange" @change="checkScaleValue" type="radio" v-model="form.scaleValue" value="priceChange" name="scaleValue" class="mr-1">
                        Price
                    </label>
                </li>
                <li>
                    <label for="percentChange">
                        <input id="percentChange" @change="checkScaleValue" type="radio" v-model="form.scaleValue" value="percentChange" name="scaleValue" class="mr-1">
                        % Change
                    </label>
                </li>
            </ul>
            <div class="form-text">* % Change auto-changes Bar Type to Line</div>
        </div>
    </div>
</template>

<script setup>
import { watch } from 'vue';

const props = defineProps({
    form: Object,
    modelValue: [String, Number, Object],
});

const emit = defineEmits(['update:modelValue']);

watch(() => props.form, (newValue) => {
    emit('update:modelValue', newValue);
}, { deep: true });

function checkScaleValue() {
    if (props.form.scaleValue === 'percentChange') {
        props.form.line = 'Line';
    }
}
</script>
